export default __webpack_public_path__ + "static/media/bell.ad2f301f.svg";